import React from 'react';

const Dashboard: React.FC = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">Dashboard</h1>
        <p className="mt-2 text-gray-600">
          Welcome to the Workflow Manager. Monitor and manage your workflow executions.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Total Workflows</h3>
          <p className="text-3xl font-bold text-blue-600 mt-2">-</p>
          <p className="text-sm text-gray-500 mt-1">All time</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Running</h3>
          <p className="text-3xl font-bold text-yellow-600 mt-2">-</p>
          <p className="text-sm text-gray-500 mt-1">Currently active</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Succeeded</h3>
          <p className="text-3xl font-bold text-green-600 mt-2">-</p>
          <p className="text-sm text-gray-500 mt-1">Completed successfully</p>
        </div>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h3 className="text-lg font-medium text-gray-900">Failed</h3>
          <p className="text-3xl font-bold text-red-600 mt-2">-</p>
          <p className="text-sm text-gray-500 mt-1">Execution errors</p>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Recent Activity</h2>
        </div>
        <div className="p-6">
          <p className="text-gray-500 text-center py-8">
            No recent workflow activity. Create your first workflow to get started.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
